import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _typeof from "@babel/runtime/helpers/esm/typeof";

/**
 *
 * 生成className
 *
 * @export
 * @param {string/number/object} ...args
 * @returns {string}
 * @example
 *
 * classnames('header', 123, { name: 'wq' }) -> 'header 123 name'
 * classnames('header', 123, { name: true }) -> 'header 123 name'
 * classnames('header', 123, { name: false }) -> 'header 123'
 * classnames('header', 123, { name: false }, ['hide']) -> 'header 123 hide'
 *
 */
export default function classNames() {
  var classes = [];
  var hasOwn = {}.hasOwnProperty;

  for (var i = 0; i < arguments.length; i++) {
    var arg = i < 0 || arguments.length <= i ? undefined : arguments[i]; // eslint-disable-next-line

    if (!arg) continue;

    var argType = _typeof(arg);

    if (argType === 'string' || argType === 'number') {
      classes.push(arg);
    } else if (Array.isArray(arg) && arg.length) {
      var inner = classNames.apply(void 0, _toConsumableArray(arg));

      if (inner) {
        classes.push(inner);
      }
    } else if (argType === 'object') {
      for (var key in arg) {
        if (hasOwn.call(arg, key) && arg[key]) {
          classes.push(key);
        }
      }
    }
  }

  return classes.join(' ');
}